import {
    PRODUCT_FILTER,
    PRODUCT_ITEMGROUP_FILTER,
    PRODUCT_PRODUCTGROUP_FILTER,
    PRODUCT_PRODUCTLINE_FILTER,
    PRODUCT_PRODUCTTYPE_FILTER,
    PRODUCT_PRODUCTVATTYPE_FILTER,
    PRODUCT_DISPLAY_FILTER,
    PRODUCT_AMOUNT_FILTER,
    PRODUCT_SALE_MONTH,
    PRODUCT_NEW_PRODUCT,
    PRODUCT_DISPLAYSALESMAN_FILTER,
    PRODUCT_PRODUCTGROUP_FOCUS_FILTER,
    PRODUCT_PRODUCTLINE_FOCUS_FILTER,
    PRODUCT_PRODUCTTYPE_FOCUS_FILTER,
    PRODUCT_SEARCH_TRIGGER
} from '../constants/ActionTypes';

const initialState = {
    productFilter: "",
    productItemGroupSelected: "",
    productProductGroupSelected: "",
    productProductLineSelected: "",
    productProductTypeSelected: "",
    productProductVatTypeSelected: "",
    productDisplaySelected: "",
    productAmountSelected: "",
    productSaleMonthSelected: new Date().getMonth() + 1,
    productNewSelected: "",
    productDisplaySalesmanSelected: "",
    productProductGroupFocus: false,
    productProductLineFocus: false,
    productProductTypeFocus: false,
    searchTrigger: 1  // เริ่มต้นที่ 1 เพื่อดึงข้อมูลครั้งแรก
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_FILTER:
            return {
                ...state,
                productSelected: action.payload,
            }
        case PRODUCT_ITEMGROUP_FILTER:
            return {
                ...state,
                productItemGroupSelected: action.payload
            }
        case PRODUCT_PRODUCTGROUP_FILTER:
            return {
                ...state,
                productProductGroupSelected: action.payload
            }
        case PRODUCT_PRODUCTLINE_FILTER:
            return {
                ...state,
                productProductLineSelected: action.payload
            }
        case PRODUCT_PRODUCTTYPE_FILTER:
            return {
                ...state,
                productProductTypeSelected: action.payload
            }
        case PRODUCT_PRODUCTVATTYPE_FILTER:
            return {
                ...state,
                productProductVatTypeSelected: action.payload
            }
        case PRODUCT_DISPLAY_FILTER:
            return {
                ...state,
                productDisplaySelected: action.payload
            }
        case PRODUCT_AMOUNT_FILTER:
            return {
                ...state,
                productAmountSelected: action.payload
            }
        case PRODUCT_SALE_MONTH:
            return {
                ...state,
                productSaleMonthSelected: action.payload
            }
        case PRODUCT_NEW_PRODUCT:
            return {
                ...state,
                productNewSelected: action.payload
            }
        case PRODUCT_DISPLAYSALESMAN_FILTER:
            return {
                ...state,
                productDisplaySalesmanSelected: action.payload
            }
        case PRODUCT_PRODUCTGROUP_FOCUS_FILTER:
            return {
                ...state,
                productProductGroupFocus: action.payload
            }
        case PRODUCT_PRODUCTLINE_FOCUS_FILTER:
            return {
                ...state,
                productProductLineFocus: action.payload
            }
        case PRODUCT_PRODUCTTYPE_FOCUS_FILTER:
            return {
                ...state,
                productProductTypeFocus: action.payload
            }
        case PRODUCT_SEARCH_TRIGGER:
            return {
                ...state,
                searchTrigger: action.payload
            }
        default:
            return state;
    }
}